<template>
    <div class="ah-page">
        <div class="page-header bottom-margin" id="project-edit-page-header">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1 v-if="!form.sno">新增委外廠商</h1>
                        <h1 v-if="form.sno">編輯委外廠商</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form :model="form" ref="form" label-position="right" label-width="200px" v-loading="isLoading">
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">基本資訊</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="caT_SNO" label="類型" :rules="rules.caT_SNO">
                            <OutsourcingTypeSelect v-model="form.caT_SNO" type="company" />
                        </el-form-item>
                        <el-form-item prop="fnam" label="公司名稱" :rules="rules.fnam">
                            <el-input v-model="form.fnam" style="max-width: 650px" @blur="handleNameBlur" :maxlength="50" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item prop="abd" label="國籍">
                            <el-radio v-model="form.abd" :label="0" @change="onAbdChanged">本國</el-radio>
                            <el-radio v-model="form.abd" :label="1" @change="onAbdChanged">境外</el-radio>
                        </el-form-item>
                        <el-form-item prop="abD_TYP" label="境外類型" v-if="form.abd == 1">
                            <el-radio v-model="form.abD_TYP" :label="2">民間</el-radio>
                            <el-radio v-model="form.abD_TYP" :label="1">公營事業</el-radio>
                            <el-radio v-model="form.abD_TYP" :label="0">政府</el-radio>
                        </el-form-item>
                        <el-form-item prop="profitType" label="營利">
                            <el-radio v-model="form.profitType" :label="1">營利事業</el-radio>
                            <el-radio v-model="form.profitType" :label="2">非營利事業<ah-tip>可無統編</ah-tip> </el-radio>
                        </el-form-item>
                        <el-form-item prop="bsn" :label="form.abd == 0 ? '統一編號' : '稅務編號'" :rules="form.abd === 0 && form.profitType === 1 ? rules.bsn : [{ required: false }]">
                            <el-input v-model.trim="form.bsn" style="max-width: 300px" :placeholder="form.abd == 0 ? '統編' : 'VAT number'" :maxlength="20" :show-word-limit="true"></el-input>
                        </el-form-item>
                        <el-form-item prop="adr" label="地址">
                            <CountrySelect v-if="form.abd == 1" v-model="form.ara" key="country-select" style="margin-bottom: 10px" />
                            <TwCountySelect v-if="form.abd == 0" v-model="form.cty" key="county" style="margin-right: 5px" />
                            <el-input v-model="form.adr" style="max-width: 500px"></el-input>
                        </el-form-item>
                        <el-form-item prop="adR_CODE" label="郵遞區號">
                            <ah-number-input v-model="form.adR_CODE" style="display: block; width: 150px" :maxlength="6" :placeholder="form.abd == 0 ? '' : 'ZIP code'"></ah-number-input>
                        </el-form-item>
                    </div>
                </div>
                <OutsourcingContactListEdit v-model="form.vendorContacts" @add="addContact" @remove="removeContact" />
                <OutsourcingBankListEdit v-model="form.vendorBanks" :form="form" no-agree-needed @add="onAddVenderBank" @delete="onDeleteVenderBank" />
                <div class="ah-panel">
                    <div class="panel-header small gray">
                        <div class="panel-title">其他</div>
                    </div>
                    <div class="panel-body">
                        <el-form-item prop="note" label="備註">
                            <el-input type="textarea" :autosize="{ minRows: 5 }" placeholder="" v-model="form.note" :maxlength="200" :show-word-limit="true"> </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div v-if="form.sno" style="text-align: right; color: #aaa; margin-bottom: 20px">
                    <span style="margin-right: 10px">最後編輯</span>
                    <span>{{ form.upD_USR }}</span>
                    <span style="margin-left: 10px">{{ form.upD_DAT | dateFormater("YYYY-MM-dd") }}</span>
                </div>
                <center>
                    <el-button type="dark" @click="handleDelete" v-if="form.sno">刪除</el-button>
                    <el-button @click="onBack()">取消</el-button>
                    <el-button type="primary" @click="onSubmit" :loading="isSubmitting" class="primary-action" style="width: 150px">{{ form.sno ? "儲存" : "新增" }}</el-button>
                </center>
            </el-form>
        </div>
    </div>
</template>
<script>
import CountrySelect from '@/components/ui/CountrySelect.vue';
import TwCountySelect from '@/components/ui/TwCountySelect.vue';
import OutsourcingTypeSelect from '@/components/ui/OutsourcingTypeSelect.vue';
import OutsourcingBankListEdit from '@/components/dashboard/Outsourcing/OutsourcingBankListEdit.vue';
import OutsourcingContactListEdit from '@/components/dashboard/Outsourcing/OutsourcingContactListEdit.vue';
import { isGuiNumberValid, isNationalIdentificationNumberValid } from 'taiwan-id-validator';
import ahNumberInput from '@/components/ui/ahNumberInput.vue';

export default {
    name: 'OutsouringEditPage',
    components: {
        CountrySelect,
        TwCountySelect,
        OutsourcingTypeSelect,
        OutsourcingBankListEdit,
        OutsourcingContactListEdit,
        ahNumberInput,
    },
    computed: {
        bsnLabel() {
            if (this.form.vdR_TYP == 'VD') return '統一編號';

            if (this.form.abd == 1) return '護照號碼';
            return '身分證號碼';
        },
    },
    data() {
        // 統一編號驗證
        const validateBsn = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('請輸入統一編號。'));
            } else {
                // 廠商
                if (this.form.vdR_TYP == 'VD') {
                    if (!isGuiNumberValid(value, true)) {
                        callback(new Error('統一編號格式不正確'));
                    } else {
                        callback();
                    }
                }
                // 勞務
                else {
                    // 本國：身分證
                    if (this.form.abd == 0) {
                        if (!isNationalIdentificationNumberValid(value)) {
                            callback(new Error('身分證號碼格式不正確'));
                        } else {
                            callback();
                        }
                    }
                    // 外國：護照號碼（無驗證）
                    else {
                        callback();
                    }
                }
            }
        };

        return {
            bankList: [],
            branchList: [],
            vendorSettings_OS: [],
            vendorSettings_VD: [],
            isLoading: false,
            isBankBranchLoading: false,
            isSubmitting: false,
            vendorDeleteBanks: [],
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
            form: {
                mno: 0, // 編號
                vdR_TYP: 'VD', // 類型（CL=客戶,VD=廠商,OS=外包）
                oS_TYP: null,
                caT_SNO: null,
                cnam: '', // 簡稱
                fnam: '', // 全名
                bsn: '', // 統編或身份證字號或護照
                bsN_NO: 0, // 無統編
                adr: '', // 地址,
                abd: 0, // 國籍 0=國內, 1=國外
                abD_TYP: null, // 0政府/1公營事業/2民間
                onf: 1, // 啟用
                bilL_DAY: '1', // 結帳日
                soO_DAY: '1', // 收款日
                adR_CODE: '',
                profitType: 1, // 營利1, 非營利2
                ara: '',
                cty: '',
                voo: '',
                note: '',
                oS_GRP: false,
                oS_GRP_FILE: '',
                oS_FRONT_FILE: '',
                oS_BACK_FILE: '',
                vendorContacts: [],
                vendorBanks: [
                    {
                        accountType: 1,
                        bnK_BOO: null,
                        bnK_DOO: null,
                        bnK_ACC: '',
                        bnK_TPC: '',
                        abroadBankName: null,
                        swiftCode: null,
                        passbookDoc: '',
                    },
                ],
                vendorBank: {
                    bnK_BOO: null,
                    bnK_DOO: null,
                    bnK_ACC: '',
                    bnK_TPC: '',
                    abroadBankName: null,
                    swiftCode: null,
                },
            },
            rules: {
                fnam: [
                    {
                        required: true,
                        trigger: 'blur',
                        validator: (rule, value, callback) => {
                            if (!value || value.trim() === '') {
                                callback(new Error('請輸入公司名稱'));
                            } else if (value.length < 2) {
                                callback(new Error('公司名稱至少需2個字元'));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
                caT_SNO: [
                    {
                        required: true,
                        message: '請選擇類型',
                        trigger: 'change',
                    },
                ],
                bsn: [
                    {
                        required: true,
                        message: '請輸入統一編號',
                        trigger: 'blur',
                    },
                    { validator: validateBsn, trigger: 'blur' },
                ],
            },
        };
    },
    mounted() {
        this.fetchTypeSettings();
        this.fetchBankList();

        // 網址中含有序號，進入編輯模式，取得資料並載入
        const { sno } = this.$route.params;
        if (sno) this.fetchExistData(sno);
        // 新增模式
        else this.addContact();
    },
    methods: {
        handleNameBlur() {
            if (this.form.fnam) {
                this.form.fnam = this.form.fnam.trim();
            }
            if (this.form.vendorBank.bnK_TPC === '') {
                this.form.vendorBank.bnK_TPC = this.form.fnam;
            }
        },
        fetchBankList() {
            this.$api({
                url: '/Tool/GetBankOptions',
                method: 'GET',
            }).then((resp) => {
                this.bankList = resp.data.options;
            });
        },
        fetchBranchList(value, refresh = true) {
            if (refresh) this.form.vendorBank.bnK_DOO = '';
            if (value) {
                this.isBankBranchLoading = true;
                this.$api({
                    url: `/Tool/GetBranchOptions?BOO=${value}`,
                    method: 'get',
                }).then((resp) => {
                    this.branchList = resp.data.options;
                    this.isBankBranchLoading = false;
                });
            }
        },
        fetchTypeSettings() {
            this.$api({
                url: '/Tool/GetDepartmentAndVendorSettings',
                method: 'get',
            }).then((resp) => {
                this.vendorSettings_OS = resp.data.vendorSettings_OS;
                this.vendorSettings_VD = resp.data.vendorSettings_VD;
            });
        },
        fetchExistData(sno) {
            this.isLoading = true;
            this.$api({
                url: `Outsourcing/GetOutsourcingInfo?sno=${sno}`,
                method: 'GET',
            }).then((resp) => {
                this.isLoading = false;

                // 如果沒有銀行資料，就補空資訊
                if (resp.data.item.vendorBank == null) {
                    resp.data.item.vendorBank = {
                        sno: resp.data.item.sno,
                        bnK_BOO: null,
                        bnK_DOO: null,
                        bnK_ACC: '',
                        bnK_TPC: '',
                    };
                }

                // 如果沒有聯絡人資料，就補空資訊
                this.form = resp.data.item;
                if (this.form.vendorContacts.length <= 0) this.addContact();

                // 載入分行下拉選單
                setTimeout(() => {
                    this.fetchBranchList(resp.data.item.vendorBank.bnK_BOO, false);
                }, 50);
                //

                //
                console.log('Outsourcing: ', resp.data.item);
            });
        },
        onTypeChanged() {
            this.form.oS_TYP = null;
        },
        onAbdChanged() {
            // 本國人
            if (this.form.abd === 0) {
                this.form.abD_TYP = null;
                this.form.ara = null;
            }

            // 外國人（境外）
            if (this.form.abd === 1) {
                this.form.abD_TYP = 2;
            }
        },
        handleDelete() {
            this.$confirm('確認要刪除？', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            })
                .then(() => {
                    this.submitDelete();
                })
                .catch(() => {});
        },
        submitDelete() {
            this.$api({
                method: 'DELETE',
                url: 'Outsourcing/DeleteOutsourcingDetail',
                data: {
                    sno: this.form.sno,
                    vdR_TYP: this.form.vdR_TYP,
                },
            }).then(() => {
                this.onBack();
            });
        },
        addContact() {
            this.form.vendorContacts.push({
                key: Date.now(),
                nam: '',
                gen: 0,
                job: '',
                tel: '',
                ext: '',
                eml: '',
                dep: '',
                onf: 1,
            });
        },
        removeContact(item) {
            const REMOVE_INDEX = this.form.vendorContacts.indexOf(item);
            if (REMOVE_INDEX !== -1) {
                if (item.sno) this.form.vendorContacts.splice(REMOVE_INDEX, 1, { ...item, onf: 0 });
                else this.form.vendorContacts.splice(REMOVE_INDEX, 1);
            }
        },
        onSubmit() {
            // 表單驗證
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 本國 資料刪除
                    if (this.form.abd === 0) {
                        this.form.abD_TYP = null;
                        this.form.ara = null;
                    }

                    // 境外 資料刪除
                    if (this.form.abd === 1) {
                        this.form.cty = null;
                    }

                    this.form.vendorBanks.forEach((item) => {
                        if (item.accountType === 1) {
                            item.abroadBankName = null;
                            item.swiftCode = null;
                        } else if (item.accountType === 2) {
                            item.bnK_BOO = null;
                            item.bnK_DOO = null;
                        }
                    });

                    this.form.oS_GRP = false;
                    this.form.oS_GRP_FILE = '';

                    this.form.fnam = this.form.fnam.trim();

                    console.log(this.form);
                    this.$api({
                        url: 'Outsourcing/UpsertOutsourcingDetail',
                        data: {
                            ...this.form,
                            vendorBanks: [...this.form.vendorBanks, ...this.vendorDeleteBanks],
                        },
                        method: 'POST',
                        crossdomain: true,
                    }).then((resp) => {
                        console.log('outsource-added', resp);

                        this.onBack('company', resp.data.sno);
                    });
                } else {
                    this.scrollViewToError();
                }
            });
        },
        scrollViewToError() {
            setTimeout(() => {
                const isError = document.getElementsByClassName('is-error');
                if (isError.length > 0) {
                    isError[0].scrollIntoView({
                        block: 'center',
                        behavior: 'smooth',
                    });
                }
            }, 100);
        },
        reset() {
            this.form.fnam = '';
            this.form.cnam = '';
            this.form.bsn = '';
            this.form.adr = '';
            this.form.bilL_DAY = '';
            this.form.soO_DAY = '';
            this.form.vendorContacts = [];
            this.form.adR_CODE = '';
            this.form.ara = '';
            this.form.cty = '';
            this.form.voo = '';
            this.currStep = 1;
            this.addContact();
        },
        onBack(outsourcingtype, outsourcingsno) {
            if (this.$route.query.from === 'payment-add') {
                this.$router.push({
                    name: 'payment-add',
                    query: { cache: 1, outsourcingtype, outsourcingsno },
                });
            } else this.$router.push({ name: 'outsourcing', query: { typ: 'vd' } });
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        onAddVenderBank() {
            this.form.vendorBanks.push({
                accountType: 1,
                bnK_BOO: null,
                bnK_DOO: null,
                bnK_ACC: '',
                bnK_TPC: '',
                abroadBankName: null,
                swiftCode: null,
                note: '',
            });
        },
        onDeleteVenderBank(index) {
            const targetBank = this.form.vendorBanks[index];
            if (targetBank) {
                const copyBank = JSON.parse(JSON.stringify(targetBank));
                copyBank.deleted = true;
                this.vendorDeleteBanks.push(copyBank);
                this.form.vendorBanks.splice(index, 1);
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";
</style>
